var CourseSettingsService = require('./course-settings-service');
var ContentServiceProvider = require('./content-service/content-service-provider');
var HomeRoomProvider = require('./homeroom/homeroom-provider');

var ContentProvider = function(){
  if (ContentProvider.prototype._singleton) {
    return ContentProvider.prototype._singleton;
  }
 
  if(CourseSettingsService.get('progressProvider') === "content-service"){
    ContentProvider.prototype._singleton = ContentServiceProvider;
  }
  else{
    ContentProvider.prototype._singleton = HomeRoomProvider;
  }

  return ContentProvider.prototype._singleton;
};

module.exports = new ContentProvider();